import Api from './rest/CrmServiceTypeApi';

export default new Api();
